<template>
    <div class="py-3">
        <router-view @childrenRoute="hideNonChildren" />
        
        <div v-if="!isChildRoute">
            <!--Cash Deposit-->
            <div class="row">
                <div class="col-md-4 mb-4">
                    <el-card shadow="hover" 
                        :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="bg-icon text-primary rounded" v-if="false"><i class="fa fa-money"></i></span> <span class="text-muted">Today Cash Deposit Count</span>
                        </div>
                        <div class="text-center" >
                            <div><h4 class="bg-opacity-blue rounded text-primary">{{ formatNum(countdata) }}</h4></div>
                            <Loader v-if="loading.summary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                        :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today Cash Deposit Total (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-blue rounded text-primary"> {{ formatNum(totalvalue) }}</h4></div>
                            <Loader v-if="loading.summary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today Average Cash Deposit (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-blue rounded text-primary">{{ formatNum(totalvalue/countdata) }}</h4></div>
                            <Loader v-if="loading.summary"/>
                        </div>
                    </el-card>
                </div>
                
            </div>

            <!--RFID-->
            <div class="row">
                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today RFID Transaction Count</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-green rounded text-success">{{ formatNum(countdatarfid) }}</h4></div>
                            <Loader v-if="loading.rfidsummary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today RFID Total Transaction (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-green text-success"> {{ formatNum(totalvaluerfid) }}</h4></div>
                            <Loader v-if="loading.rfidsummary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today Average RFID (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-green text-success">{{ formatNum(totalvaluerfid/countdatarfid) }}</h4></div>
                            <Loader v-if="loading.rfidsummary"/>
                        </div>
                    </el-card>
                </div>
            </div>

            <!--Voucher-->
            <div class="row">
                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today Voucher Transaction Count</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-yellow rounded text-warning">{{ formatNum(countdatavoucher) }}</h4></div>
                            <Loader v-if="loading.vouchersummary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today Voucher Total Transaction (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-yellow rounded text-warning"> {{ formatNum(totalvaluevoucher) }}</h4></div>
                            <Loader v-if="loading.vouchersummary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Today Average Voucher (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="bg-opacity-yellow rounded text-warning">{{ formatNum(totalvaluevoucher/countdatavoucher) }}</h4></div>
                            <Loader v-if="loading.vouchersummary"/>
                        </div>
                    </el-card>
                </div>
            </div>

            <!--EDC/BANK-->
            <div class="row">
                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Yesterday EDC Transaction Count</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="text-orange bg-opacity-orange">{{ formatNum(countdatabank) }}</h4></div>
                            <Loader v-if="loading.banksummary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Yesterday EDC Total Transaction (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="text-orange bg-opacity-orange"> {{ formatNum(totalvaluebank) }}</h4></div>
                            <Loader v-if="loading.banksummary"/>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover"
                    :body-style="{ padding: '10px' }">
                        <div slot="header" class="clearfix text-center">
                            <span class="text-muted">Yesterday Average EDC (IDR)</span>
                        </div>
                        <div class="text-center">
                            <div><h4 class="text-orange bg-opacity-orange">{{ formatNum(totalvaluebank/countdatabank) }}</h4></div>
                            <Loader v-if="loading.banksummary"/>
                        </div>
                    </el-card>
                </div>
            </div>

            <!--All Daily TRansaction Chart-->
            <div class="row">
                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div class="text-center">
                            <span><strong>All Daily Transactions This Month</strong></span>
                            <div class="mt-4">
                                <LineChart v-loading.body="loading.alldailytransaction" :data="chartdataall" :width="500" :height="180" style="margin-top:20px;"/>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div class="text-center">
                            <span><strong>Daily Transactions <span class="text-primary">Cash Deposit</span> Comparison This Month vs. Last Month</strong></span>
                            <div class="mt-4">
                                <LineChart v-loading.body="loading.dailytransaction" :data="chartdata" :width="500" :height="180" style="margin-top:20px;"/>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div class="text-center">
                            <span><strong>Daily Transactions <span class="text-success">RFID</span> Comparison This Month vs. Last Month</strong></span>
                            <div class="mt-4">
                                <LineChart v-loading.body="loading.rfiddailytransaction" :data="chartdatarfid" :width="500" :height="180" style="margin-top:20px;"/>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div class="text-center">
                            <span><strong>Daily Transactions <span class="text-warning">VOUCHER</span> Comparison This Month vs. Last Month</strong></span>
                            <div class="mt-4">
                                <LineChart v-loading.body="loading.voucherdailytransaction" :data="chartdatavoucher" :width="500" :height="180" style="margin-top:20px;"/>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div class="text-center">
                            <span><strong>Daily Transactions <span class="text-orange">EDC</span> Comparison This Month vs. Last Month</strong></span>
                            <div class="mt-4">
                                <LineChart v-loading.body="loading.bankdailytransaction" :data="chartdatabank" :width="500" :height="180" style="margin-top:20px;"/>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>


        </div>
    </div>
</template>


<script>
import Finance from '@/components/page/Finance.js'
import ReportResultTable from '@/views/pages/ReportResultTableHutang.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: Finance,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		//ReportResultTable,
		LineChart,
		//BarChart,
		Loader,
	},

	data(){
		return {
            isChildRoute: false,
            chartdata: [],
            chartdataall: [],
            chartdatarfid: [],
            chartdatavoucher: [],
            chartdatabank: [],

            countdata: 0,
            totalvalue: 0,

            countdatarfid: 0,
            totalvaluerfid: 0,

            countdatavoucher: 0,
            totalvaluevoucher: 0,

            countdatabank: 0,
            totalvaluebank: 0,

            dailytransaction: [],
            dailytransactionall: [],
            dailytransactionrfid: [],
            dailytransactionvoucher: [],
            dailytransactionbank: [],

			limit: 100,
            loading: {
                summary: false,
                dailytransaction: false,
                alldailytransaction: false,
                rfidsummary: false,
                rfiddailytransaction: false,
                vouchersummary: false,
                voucherdailytransaction: false,
                banksummary: false,
                bankdailytransaction: false,
            }
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	}, 
    mounted() {
        this.hideNonChildren();
		this.getSummary()
		this.getDailyTransaction()

        this.getSummaryRfid()
		this.getDailyTransactionRfid()

        this.getSummaryVoucher()
		this.getDailyTransactionVoucher()

        this.getSummaryBank()
		this.getDailyTransactionBank()

        this.getDailyTransactionAll()
    },
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/finance/cash-deposit';
        },

        async getSummary() {
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/cashdepositsummary?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            //
			this.loading.summary = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.countdata = response.data.data.count;
                    this.totalvalue = response.data.data.total;
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.summary = false;
				})
		},

        async getDailyTransaction(){
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/cashdepositdailytransaction?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            
			this.loading.dailytransaction = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.dailytransaction = response.data.data;
                    let legend = 'MonthCategory';
                    let valuecol = 'TotalValue';
                    let label = 'Day';
                    let prefix = '';
                    let colors = ['#BCBBD6','#409EFF']; //#583EC3
                    this.chartdata = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, colors, false, false, false)
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.dailytransaction = false;
				})
		},

        async getSummaryRfid() {
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/rfidsummary?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            //
			this.loading.rfidsummary = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.countdatarfid = response.data.data.count;
                    this.totalvaluerfid = response.data.data.total;
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.rfidsummary = false;
				})
		},

        async getDailyTransactionRfid(){
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/rfiddailytransaction?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            
			this.loading.rfiddailytransaction = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.dailytransactionrfid = response.data.data;
                    let legend = 'MonthCategory';
                    let valuecol = 'TotalValue';
                    let label = 'Day';
                    let prefix = '';
                    let colors = ['#BCBBD6','#67C23A']; //#583EC3
                    this.chartdatarfid = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, colors, false, false, false)
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.rfiddailytransaction = false;
				})
		},

        async getSummaryVoucher() {
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/vouchersummary?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            //
			this.loading.vouchersummary = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.countdatavoucher = response.data.data.count;
                    this.totalvaluevoucher = response.data.data.total;
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.vouchersummary = false;
				})
		},

        async getDailyTransactionVoucher(){
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/voucherdailytransaction?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            
			this.loading.voucherdailytransaction = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.dailytransactionvoucher = response.data.data;
                    let legend = 'MonthCategory';
                    let valuecol = 'TotalValue';
                    let label = 'Day';
                    let prefix = '';
                    let colors = ['#BCBBD6','#E6A23C']; //#583EC3
                    this.chartdatavoucher = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, colors, false, false, false)
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.voucherdailytransaction = false;
				})
		},

        async getSummaryBank() {
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/edcsummary?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            //
			this.loading.banksummary = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.countdatabank = response.data.data.count;
                    this.totalvaluebank = response.data.data.total;
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.banksummary = false;
				})
		},

        async getDailyTransactionBank(){
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/edcdailytransaction?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            
			this.loading.bankdailytransaction = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.dailytransactionbank = response.data.data;
                    let legend = 'MonthCategory';
                    let valuecol = 'TotalValue';
                    let label = 'Day';
                    let prefix = '';
                    let colors = ['#BCBBD6','#F06548']; //#583EC3
                    this.chartdatabank = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, colors, false, false, false)
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.bankdailytransaction = false;
				})
		},

        async getDailyTransactionAll(){
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/finance/alldailytransaction?'
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            
			this.loading.alldailytransaction = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.dailytransactionall = response.data.data;
                    let legend = 'TransactionType'; //MonthCategory
                    let valuecol = 'TotalValue';
                    let label = 'Day';
                    let prefix = '';
                    let colors = ['#409EFF','#67C23A','#E6A23C','#F06548']; //#583EC3
                    this.chartdataall = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, colors, false, false, false)
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.alldailytransaction = false;
				})
		},

    }
}
</script>

<style>

.el-card__header {
    padding: 10px 10px;
}

.bg-icon {
    background-color: #D9ECFF;
    padding: 6px 8px;
    font-size: 12px;
}

.bg-opacity-blue {
    background-color: #ECF5FF;
    padding: 6px 4px;
}

.bg-opacity-green {
    background-color: #F0F9EB;
    padding: 6px 4px;
}

.bg-opacity-yellow {
    background-color: #FDF6EC;
    padding: 6px 4px;
}

.text-orange {
    color:#F06548;
}

.bg-opacity-orange {
    background-color: rgba(240, 101, 72, 0.1);
    padding: 6px 4px;
}

</style>